import React from 'react';
import { Header } from '@/components';
import HeroSection from '@/features/home/components/HeroSection';
import SearchAndFilterBar from '@/features/home/components/SearchAndFilterBar';
import VenueShowcase from '@/features/home/components/VenueShowcase';
import ClubsSection from '@/features/home/components/ClubsSection';
import PopularEvents from '@/features/home/components/PopularEvents';
import CTASection from '@/features/home/components/CTASection';
import Footer from '@/components/Footer';

const HomePage: React.FC = () => {
  return (
    <>
      <Header showHamburger={false} />
      <HeroSection />
      <SearchAndFilterBar />
      <VenueShowcase />
      <ClubsSection />
      <PopularEvents />
      <CTASection />
      <Footer />
    </>
  );
};

export default HomePage;
